import axios, { AxiosRequestConfig as _AxiosRequestConfig, Method } from 'axios'
import { message } from 'antd'
import { routerStore } from '../store'

axios.defaults.withCredentials = true

export interface AxiosRequestConfig extends _AxiosRequestConfig {
  startTime?: Date
}

export interface HttpResquest {
  get?(url: string, data: object, baseUrl?: string, config?: object): Promise<any>
  post?(url: string, data: object, baseUrl?: string, config?: object): Promise<any>
  delete?(url: string, data: object, baseUrl?: string, config?: object): Promise<any>
  put?(url: string, data: object, baseUrl?: string, config?: object): Promise<any>
}

enum HTTPERROR {
  LOGICERROR,
  TIMEOUTERROR,
  NETWORKERROR
}

const TOKENERROR = [401, 402, 403]

const DEFAULTCONFIG = {
  baseURL: process.env.BASEURL,
  withCredentials: true
}

const http: HttpResquest = {}
const methods: Method[] = ['get', 'post', 'put', 'delete']

let authTimer: NodeJS.Timer = null

const isSuccess = res => res.code === 200

methods.forEach(v => {
  http[v] = (url: string, data: object, baseUrl?: string, config?: object) => {
    const axiosConfig: AxiosRequestConfig = {
      method: v,
      url,
      baseURL: baseUrl || DEFAULTCONFIG.baseURL,
      ...config
    }
    const instance = axios.create(DEFAULTCONFIG)
    // Add a request interceptor
    instance.interceptors.request.use(
      cfg => {
        cfg.params = { ...cfg.params, ts: Date.now() / 1000 }
        return cfg
      },
      error => Promise.reject(error)
    )
    // Add a response interceptor
    instance.interceptors.response.use(
      response => {
        const rdata =
          typeof response.data === 'object' && !isNaN(response.data.length) ? response.data[0] : response.data
        // 注释掉需要登陆跳转逻辑
        if (TOKENERROR.includes(+rdata.code)) {
          message.destroy()
          message.error('未登录')
          clearTimeout(authTimer)
          authTimer = setTimeout(() => {
            console.log('response', response)
            const { url } = response.config
            if (url.startsWith('editor-api')) {
              routerStore.history.replace('/jalogin')
            } else {
              routerStore.history.replace('/login')
            }
            // location.replace('web/#/login')
          }, 300)
          return
        }
        if (!isSuccess(rdata)) {
          return Promise.reject({
            message: rdata.message,
            errCode: rdata.code,
            type: HTTPERROR[HTTPERROR.LOGICERROR],
            config: response.config
          })
        }
        return rdata
      },
      error => {
        if (TOKENERROR.includes(error.response.status)) {
          message.destroy()
          message.error('验证失败，请登录!')
          clearTimeout(authTimer)
          authTimer = setTimeout(() => {
            // location.replace('web/#/login')
            routerStore.history.replace('/login')
          }, 300)
          return
        }

        //爬虫验证逻辑命中
        if (error.response.status === 509) {
          const html = error.response.data

          const verifyWindow = window.open('', '_blank', 'height=400,width=560')

          verifyWindow.document.write(html)

          verifyWindow.document.getElementById('baseUrl').value = 'https://www.iacademic.info/'
        }

        return Promise.reject({
          message: error.response.statusText || error.message || '网络错误',
          type: /^timeout of/.test(error.message)
            ? HTTPERROR[HTTPERROR.TIMEOUTERROR]
            : HTTPERROR[HTTPERROR.NETWORKERROR],
          config: error.config
        })
      }
    )
    if (v === 'get') {
      axiosConfig.params = data
    } else {
      axiosConfig.data = data
    }
    axiosConfig.startTime = new Date()
    return instance
      .request(axiosConfig)
      .then(res => res)
      .catch(err => {
        message.destroy()
        message.error(err.response || err.message || err.stack || '未知错误')
        return Promise.reject(
          axiosConfig.url.includes('autoScript.set') ? { err } : { err, stack: err.message || err.stack || '' }
        )
      })
  }
})

export default http
